import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { isNil } from 'lodash';
import { useModal } from '../../../src/store/ModalContext';

// Icons
import TrashIcon from '../../../public/icons/trash.svg';
import triggerConfirmDelete from '../../../src/utils/booking/triggerConfirmDelete';

function TrashItem({
  itemId, playerId, hostingId, type, className,
}) {
  const { openModal } = useModal();

  const handleConfirmTrash = () => {
    if (!isNil(playerId)) triggerConfirmDelete.deleteItemByPlayer(openModal, type, itemId, playerId);
    if (!isNil(hostingId)) triggerConfirmDelete.deleteHosting(openModal, type, hostingId);
  };

  return (
    <button
      type="button"
      className={className || ''}
      onClick={handleConfirmTrash}
    >
      <TrashIcon />
    </button>
  );
}

TrashItem.propTypes = {
  itemId: PropTypes.number,
  playerId: PropTypes.number,
  hostingId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
};

TrashItem.defaultProps = {
  playerId: null,
  hostingId: null,
  itemId: null,
  className: null,
};

export default TrashItem;
